export const client = {
  header_title: "Clients",
  create_form: {
    title: "Créer un client",
    name: "Nom",
    name_placeholder: "Nom du client",
    email: "Email",
    email_placeholder: "Email du client",
    address: "Adresse",
    address_placeholder: "Adresse du client",
    phone: "Téléphone",
    phone_placeholder: "Téléphone du client",
    submit: "Créer",
    creating: "Création...",
    updating: "Mise à jour...",
    update: "Modifier",
    create_success: "Client crée avec succès!",
    update_success: "Client mis à jour avec succès!",
    deactivate_success: "Client desactivé avec succès!",
    create_error: "Erreur lors de la création du client",
    update_error: "Erreur lors de la mise à jour du client",
    deactivate_error: "Erreur lors de la desactivation du client",
    status: "Statut",
  },
  actions: {
    edit: "Modifier",
    deactivate: "Desactiver",
    activate: "Activer",
  },
  deactivate_dialog: {
    title: "Desactiver le client",
    description: "Etes-vous sur de vouloir desactiver ce client?",
    confirm: "Desactiver",
    cancel: "Annuler",
  },
  add_user: "Ajouter un utilisateur",
  remove_user: "Supprimer l'utilisateur",
  user_clients: "Clients utilisateurs",
  status_changed: "Statut changé avec succès!",
  status_change_error: "Erreur lors de la mise à jour du statut",
};
